<template>
 <div class="container my-4">
  <div id="carouselExampleControlss" class="carousel slide" data-bs-ride="carousel">
    <div class="carousel-inner">
       <div class="carousel-item " :class="sliderItem.active" v-for="sliderItem in mslider" :key="sliderItem.id">
        <a href="javascript:void(0)" v-if="sliderItem.link && sliderItem.link == 'null'">
          <img :src="'https://radgroups.ir/'+sliderItem.img" class="d-block w-100 image-slider" alt="Wild Landscape" style="max-height: 200px;min-height: 200px;border-radius: 10px;"/>
        </a>
        <a :href="sliderItem.link" v-else>
          <img :src="'https://radgroups.ir/'+sliderItem.img" class="d-block w-100 image-slider" alt="Wild Landscape" style="max-height: 200px;min-height: 200px;border-radius: 10px;"/>
        </a>
      </div>
    </div>
    <div class="carousel-indicators mx-auto p-1 rounded" style="max-width: fit-content;background-color:rgba(114 ,142 ,167,.7)" v-if="mslider && mslider.length > 1">
      <button
        v-for="sliderItem in mslider" :key="sliderItem.id" 
        :class="sliderItem.active"
        :data-bs-slide-to="sliderItem.order"
        :id="'ind'+sliderItem.id"
        :aria-label="'Slide '+(sliderItem.order+1)"
        type="button"
        data-bs-target="#carouselExampleControlss"
        aria-current="false"
        class="my-btn1 mr-0 ra-mx-1"
      ></button>
    </div>
  </div>
</div>
</template>
<script setup>
import {ref,onMounted} from 'vue';
import { useRoute } from 'vue-router';
let route = useRoute()
// console.log(route);
let mslider = ref([]);
onMounted(() => {
  getSlider();
})
async function getSlider(){
  let zone = route.name + route.params.item
  let response = await fetch('https://radap.ir/Backend/api/section/pages/main/banner.php?zone='+zone)
  let data = await response.json()
      mslider.value = data;
      if(mslider.value.length > 1){
        setTimeout(() => {
          if(document.querySelector('.my-btn1')){
            document.querySelector('.my-btn1').click()
          }
        }, 1000);
      }
}

</script>
      
<style scoped>
    *{
      touch-action:pan-y;
      user-select: auto;
    }
    .carousel-item {
    transition: transform .3s ease-in-out !important;
    }
    @media(max-width:454px){
        .image-slider {
            max-height: 4cm !important;
            min-height: 4cm !important;
        }
    }
    @media(min-width:455px){
        .image-slider {
            max-height: 6cm !important;
            min-height: 6cm !important;
        }
    } 
    .my-btn1{
      border-radius: 5px;
        width: 6px;
        height: 6px;
        background-color: rgb(238 241 249);
        margin-left: 0;
        border: none;
        opacity: .5;
    }
    .carousel-indicators .active{
      opacity: 1 !important;
    }
    @media (max-width: 997px)
      {
        .carousel-indicators {
            bottom: -5% !important;
        }
      }
      .carousel-indicators {
          bottom: -5%;
      }
      .ra-mx-1{
  margin-right:1px !important;
  margin-left:1px !important;
}
</style>